// extracted by mini-css-extract-plugin
export default {"performanceSpecsSection":"KqKjpTt1rFjZZ95BzGwG","heading":"r3Z9kkOVwUeeqRagAokI","cards":"OVMZCcOprSkUEnrNOQ1D","integrationCard":"xJTGk7IlHp1XVmi1yidG"};